import { useMutation } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useHousehold } from '@/context/HouseholdContext'

// Conclui o wizard de primeiro acesso: grava idioma (por usuário) + moeda
// principal (do household) e marca households.onboarded=true. Depois disso o
// gate em App.tsx para de exibir o wizard.
export function useCompleteOnboarding() {
  const { householdId, userId, refresh } = useHousehold()
  return useMutation({
    mutationFn: async ({ language, baseCurrency }: { language: string; baseCurrency: string }) => {
      if (!userId) throw new Error('Sem usuário autenticado')
      const [{ error: profErr }, { error: houErr }] = await Promise.all([
        supabase.from('profiles').upsert({ user_id: userId, locale: language }, { onConflict: 'user_id' }),
        supabase
          .from('households')
          .update({ language, base_currency: baseCurrency, enabled_currencies: [baseCurrency], onboarded: true })
          .eq('id', householdId),
      ])
      if (profErr) throw profErr
      if (houErr) throw houErr

      try {
        await supabase.functions.invoke('sync-rates', { body: { mode: 'daily' } })
      } catch (e) {
        console.warn('[sync-rates] falhou no onboarding:', e)
      }
    },
    onSuccess: () => refresh(),
  })
}
